import type { BulkDriverFormValues } from '../types'
import { useCallback } from 'react'
import { useResetEditingState } from '@/atoms'
import { updateDrivers } from '@/features/domain/driver'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

export function useOnSubmit(drivers: uui.domain.client.rm.ExtendedDriver[]) {
  const stopEditing = useResetEditingState()
  const dispatch = useAppDispatch()
  const toast = useNotification()

  return useCallback(
    async (formValues: BulkDriverFormValues) => {
      try {
        const bulkDriverUpdate = computeDriversValues(formValues, drivers)
        const thunkResult = await dispatch(updateDrivers(bulkDriverUpdate))

        if (!updateDrivers.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        stopEditing()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [dispatch, stopEditing, toast],
  )
}

/**
 * Takes the formValues, filter only the `exact` values
 *
 * @param formValues form values
 * @returns uui.domain.ui.forms.BulkDriverUpdate
 */
function computeDriversValues(
  formValues: BulkDriverFormValues,
  drivers: uui.domain.client.rm.ExtendedDriver[],
): uui.domain.ui.forms.BulkDriverUpdate {
  const bulkDriverUpdate: uui.domain.ui.forms.BulkDriverUpdate = {
    driverIds: drivers.map(d => d.id),
  }

  for (const [key, value] of Object.entries(formValues)) {
    if (value.status === 'exact') {
      const val =
        key === 'mobileFutureDaysVisibility' ? parseInt(value.value as string) : value.value
      bulkDriverUpdate[key] = val
    }
  }

  return bulkDriverUpdate
}
